export enum LocaleCodes {
  // ENGLISH = 'en',
  KYRGYZ = 'ky',
  RUSSIAN = 'ru',
}
